/**
 * 08 渐进充值：crypto 扩展默认关闭（08-main 无 OpenDisk/Crypto）。
 */
export const RECHARGE_PROGRESSIVE_DEFAULT_CRYPTO_ENABLED = false;

/** 08 充值主按钮渐变（与 theme rechargeButtonLinearGradient / primary 一致） */
export const RECHARGE_PROGRESSIVE_SUBMIT_BUTTON_BACKGROUND =
  'linear-gradient(rgb(22, 107, 229), rgb(22, 107, 229))';

/** 展示余额卡底部 Current Method（BIR 默认，见包仓 recharge-plate-host-config-sync.md） */
export const RECHARGE_PROGRESSIVE_BALANCE_SHOW_METHOD_SECTION = true;
